<div class="dialog-container">
  <!-- Header Section -->
  <div class="dialog-header">
    <div class="d-flex align-items-center">
      <mat-icon class="mr-2">{{ 'supervisor_account' }}</mat-icon>
      <div class="title">
        {{
          data?.isClaimHandler
            ? 'Reassign Claim Handler'
            : 'Reassign Account Handler'
        }}
      </div>
    </div>
    <div class="subtitle">
      {{
        data?.isClaimHandler
          ? 'Reassign the claim handler'
          : 'Reassign the account handler'
      }}
    </div>
  </div>
  <mat-divider></mat-divider>

  <!-- Scrollable Content Section -->
  <form [formGroup]="form" class="form-container">
    <div class="row">
      <div class="col-12">
        <el-async-autocomplete
          *ngIf="!isLoadedAvatars"
          [label]="
            data?.isClaimHandler
              ? ('claims.create.claim-handler' | translate)
              : ('leads.add-lead.fields.account-handler' | translate)
          "
          [filteredOptionsFromParent]="
            accountHandlerUsersListForAsyncAutoComplete
          "
          [selectionModes]="SELECTION_MODE.CHIPS"
          [size]="10"
          [total]="totalAccountHandlerUsers"
          [isMultiSelectEnabled]="false"
          [isRequired]="isRequired(this.form.controls.agent)"
          [selectedForEdit]="selectedAccountHandlerUserValues"
          (selectedItems)="selectAccountHandlerUser($event)"
          (asyncInput)="onFilterUsers($event)"
          [hasAvatar]="true"
          [markAsTouched]="accountHandlerMarkAsTouched"
          [ngClass]="readOnly ? 'click-blocker' : ''"
        >
        </el-async-autocomplete>
      </div>
    </div>
  </form>

  <div class="mt-2 dialog-actions" align="end">
    <button mat-button (click)="onCancel()">
      {{ 'shared.remarks-popup.cancel' | translate }}
    </button>
    <button
      mat-flat-button
      color="accent"
      (click)="onSave()"
      [disabled]="!form.valid"
    >
      {{ 'shared.remarks-popup.save' | translate }}
    </button>
  </div>
</div>
